import { render, staticRenderFns } from "./user-admin-display-new.vue?vue&type=template&id=06b55914&scoped=true&"
import script from "./user-admin-display-new.vue?vue&type=script&lang=js&"
export * from "./user-admin-display-new.vue?vue&type=script&lang=js&"
import style0 from "./user-admin-display-new.vue?vue&type=style&index=0&id=06b55914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b55914",
  null
  
)

export default component.exports